import React from 'react';

import { CreditNote } from '@work4all/components/lib/components/convert-popover/ConvertableTypes';

import { CloneConvertDialogProps } from '../types';

import { ConvertErpDialog } from './ConvertErpDialog';
import { CopyErpDialog } from './CopyErpDialog';

export const CloneConvertDialog = (props: CloneConvertDialogProps) => {
  const { sourceEntity: entity, targetEntity } = props;
  if (props.targetEntityOptions?.convertableTarget === CreditNote)
    return <ConvertErpDialog {...props} />;

  return (
    <React.Fragment>
      {targetEntity === entity ? <CopyErpDialog {...props} /> : null}
      {targetEntity && targetEntity !== entity ? (
        <ConvertErpDialog {...props} />
      ) : null}
    </React.Fragment>
  );
};
